import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=317fe066"
import script from "./GroupConfig.vue?vue&type=script&lang=js"
export * from "./GroupConfig.vue?vue&type=script&lang=js"
import style0 from "./GroupConfig.vue?vue&type=style&index=0&id=317fe066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports